import mmenu from "./menu";
import Accordion from "./accordians";
import { domReady } from "./helpers";
import Lightbox from './lightbox'
import Gallery from "./gallery";
import MicroModal from 'micromodal';  // es6 module
import Foldout from "./foldout";
import Expandbox from "./expandbox";
import Googlemaps from "./googlemaps";

//import PhotoSwipeLightbox from 'photoswipe/lightbox';

//import mainmenu from "./main-menu";

//import Gallery from "./gallery";
// import FilterList from './filter';

// // Claess
// import Accordion from "./accordians";
// //import ScrollHeader from "./scroll-header";
// import Header from "./header";
// import Gallery from "./gallery";
// import observer from './scroll';
//import list from "./list";

import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'

//import Glide from '@glidejs/glide'

// import "./minicart";
// import "./productgallery";

class App {
    
    static start() {
        return new App()
    }

    constructor() {
        Promise
            .all([
                domReady()
            ])
            .then(
                this.init.bind(this)
            )
    }

    
 
    init() {
        console.info('🚀App:init');

        mmenu();

        new Gallery('.js-gallery-image');

        Lightbox();

        [...document.querySelectorAll('[data-accordion]') ].forEach(accordian => {
    
            new Accordion( accordian );
        });

        // Search
        let togglesearch = document.querySelector('.o-global-search');

        togglesearch.addEventListener('click', event => {
            document.body.classList.toggle('search-box-open');
        });


        Foldout();

        Expandbox();

        Googlemaps();

        // Modal persons
        MicroModal.init({
            onShow: modal => {
                if (modal.classList.contains('modal--embed')) {
                    // copy
                    let embedDivOrig = modal.querySelector('.modal-embed-orig')
                    let embedDiv = modal.querySelector('.modal-embed')
                    embedDiv.innerHTML = embedDivOrig.innerHTML
                }
            },
            onClose: modal => {
                if (modal.classList.contains('modal--embed')) {
                    let embedDiv = modal.querySelector('.modal-embed')
                    embedDiv.innerHTML = ''
                }
            }

        });


        // Add label
        let gfields = document.querySelectorAll('.page-template-password-login .gfield');

        if (typeof(gfields) != 'undefined' && gfields != null) {
            gfields.forEach(gfield => {
                let label = gfield.querySelector('label');
                let input = gfield.querySelector('input');
                
                let labeltext = label.textContent;

                // Translate
                if(document.documentElement.lang == 'sv-SE') {
                    switch (labeltext) {
                        case 'Username' :
                            labeltext = 'Användarnamn';
                            break;
                        case "Password" : 
                            labeltext = 'Lösenord';
                            break;
                    }
                }
                input.setAttribute('placeholder', labeltext)
            });
        }

        // Produducts
        let sliders = document.querySelectorAll('.glide');


        if (typeof(sliders) != 'undefined' && sliders != null) {

            
            for (var i = 0; i < sliders.length; i++) {
                

                let perview = sliders[i].getAttribute('data-glide-perView');
                let perview480 = sliders[i].getAttribute('data-glide-perView-480');
                let perview1200 = sliders[i].getAttribute('data-glide-perView-1200');


                var glide = new Glide(sliders[i], {                
                    type: 'slider',
                    perView: perview,
                    startAt: '0',
                    focusAt: '0',
                    gap: 30,
      
                    //bound: true,
                    breakpoints: {
                    1200: {
                        perView: perview1200
                    },
                    480: {
                        perView: perview480
                    }
                    }
                }).mount({ Controls, Breakpoints })

                
            }
            

        }

        
        // SF Toggle
        const liElements = document.querySelectorAll('.sf-field-taxonomy-articles_tax, .sf-field-taxonomy-articles_tags');
        let activeElement = null;
      
        if (liElements.length > 0)  {

            liElements[0].classList.add('active');
            
            activeElement = liElements[0]

            const mediaQuery = window.matchMedia('(min-width: 1200px)')
            
            function handleTabletChange(e) {
            
                if (e.matches) {
                    liElements[0].classList.add('active');
                    liElements[1].classList.add('active');
                    
                }
            }
            
              // Register event listener
            mediaQuery.addListener(handleTabletChange)

            // Initial check
            handleTabletChange(mediaQuery)

            
            const toggleAccordion = (element) => {
                // if (element === activeElement) {
                //     element.classList.remove('active');                
                //     activeElement = null;
                // } else {
                //     if (activeElement) {
                //         activeElement.classList.remove('active');
                //     }
                //     element.classList.add('active');
                //     activeElement = element;
                // }
                element.classList.toggle('active')
            };
        
            liElements.forEach((li) => {
                let headline = li.querySelector('h4')
                headline.addEventListener('click', () => {
                    toggleAccordion(li);
                });
            });
        }

    }

}

App.start()




